<script setup lang="ts">
import type { ButtonSize } from '@global-types/buttonSize.ts';
import type { ButtonVariant } from '@global-types/buttonVariant';
import type { LinkTarget } from '@global-types/linkTarget';
import { computed } from 'vue';

const { variant, size = 'default' } = defineProps<{
  href: string,
  variant?: ButtonVariant,
  size?: ButtonSize,
  target?: LinkTarget,
}>();

const classes = computed<string[]>(() => {
  const classList = [];
  if (variant) {
    classList.push(`btn--${variant}`);
  }

  classList.push(`btn--${size}`);

  return classList;
});
</script>

<template>
  <a
    class="btn"
    :class="classes"
    :href="href"
    :target="target"
  >
    <slot />
  </a>
</template>
